import { render } from "./ButtonEditMenuComponent.vue?vue&type=template&id=0040ad90&scoped=true"
import script from "./ButtonEditMenuComponent.vue?vue&type=script&lang=js"
export * from "./ButtonEditMenuComponent.vue?vue&type=script&lang=js"

import "./ButtonEditMenuComponent.vue?vue&type=style&index=0&id=0040ad90&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0040ad90"]])

export default __exports__